import Index from './index.vue'
import Create from './components/Create.vue'
import List from './components/List.vue'
import Search from './view/Search.vue'
import Profile from './view/Profile.vue'
import Home from './view/Home.vue'

export default [
  {
    path: 'leads',
    name: 'leads',
    component: Index,
    title: 'Leads',
    redirect: { name: 'lead-home' },
    children: [
      {
        path: 'create',
        name: 'lead-create',
        component: Create,
      },
      {
        path: 'search',
        name: 'search-lead',
        component: Search,
      },
      {
        path: 'list',
        name: 'lead-list',
        component: List,
      },
      // {
      //   path: 'edit',
      //   name: 'category-edit',
      //   component: Edit,
      // },
      {
        path: 'profile/:id',
        name: 'lead-profile',
        component: Profile,
      },
      {
        path: 'home',
        name: 'lead-home',
        component: Home,
      },
    ],
  },
]
